export default (state, action) => ({
  ...state,
  processes: [
    ...state.processes.filter(process => !action.payload.includes(process.id)),
  ],
})
